export default __webpack_public_path__ + "static/FancyMediaContentFourTeen-f67de49d133c5f1a1c7f1f909671b68d.webp";